<template>
  <div class="tabs_content">
    <section v-if="entities">
      <template>
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search" />
          </div>

        </div>

        <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="subscribers-favorite-shows">
            <table class="vypis">
              <thead>
              <tr v-if="entities.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in tableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>
              <tbody>
              <FavoriteShowsRow
                  v-for="entity in entities"
                  :entity="entity"
                  :enabled="entity.favorite_show_enabled"
                  :selectedEntities="selectedEntities"
                  @input="select"
                  :key="entity.id"
                  :is-deletable="isEditable"
                  @deleteFavoriteShow="onDeleteFavoriteShow" />
              <tr v-if="entities.length === 0">
                <td colspan="6" v-translate>Nebyly nalezeny žádné oblíbené pořady.</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-favorite-shows"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import FavoriteShowsRow from "./FavoriteShowsRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailFavoriteShows",
  components: { FavoriteShowsRow },
  mixins: [listActions],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(SubscriberService, FavoriteShowService) {
    this.subscriberService = SubscriberService
    this.favoriteShowService = FavoriteShowService
    this.getEntities()
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
    };
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberFavoriteShows(this.entity.id, params).then((data) => {
        this.entities = data['favorite_shows']
        this.totalCount = data['totalCount']
      })
    },
    onDeleteFavoriteShow(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteFavoriteShow');
      } else {
        this.favoriteShowService.deleteEntity(id, { id_selected_operator: this.$_loggedUser_selectedOperatorId })
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeleteFavoriteShow(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberFavoriteShows(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['favorite_shows']);
      })
    },
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sName' },
        { id: 2, name: this.$gettext('Uživatelský profil') },
        { id: 3, name: this.$gettext('Vytvořilo zařízení') },
        { id: 4, name: this.$gettext('Datum vytvoření'), column: 'sDateCreated' },
      ]
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'id_subscriber_profile': {
          name: this.$gettext('Uživatelský profil'), callback: (entity) => {
            return entity.subscriber_profile_name
          }
        },
        'device_name': { name: this.$gettext('Vytvořilo zařízení') },
        'timestamp_created': { name: this.$gettext('Datum vytvoření') }
      }
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/favoriteShows/FavoriteShows.vue